import { createSelector } from 'reselect';

import type { TemporaryStep } from './steps.types';
import type { RootState } from '../store';

const selectStepsState = (state: RootState) => state.steps;

export const selectCurrentStep = createSelector(selectStepsState, (steps) => steps.currentStep);

export const selectCurrentStepGroupId = createSelector(
  selectCurrentStep,
  (currentStep) => currentStep?.groupId,
);

export const selectCurrentStepId = createSelector(
  selectCurrentStep,
  (currentStep) => currentStep?.id,
);

export const selectTemporaryStep = createSelector(selectCurrentStep, (currentStep) =>
  currentStep?.isTemporary ? (currentStep as TemporaryStep) : undefined,
);
